import React from "react";
import PropTypes from "prop-types";
import Dropzone from "react-dropzone";
import autoBind from "react-autobind";

import { generateUniqueId } from "../../utils";

class AvatarUpload extends React.Component {
  constructor(props) {
    super(props);

    this.state = { files: [] };

    autoBind(this);
  }

  onDrop = (files) => {
    this.setState({ files });
    this.props.onDrop(files);
  };

  render() {
    return (
      <Dropzone onDrop={this.onDrop} className="avatar-upload">
        {this.state.files.length
          ? this.state.files.map((file) => (
              <div
                key={generateUniqueId()}
                className="profile avatar"
                style={{ overflow: "visible", height: "120px", width: "120px" }}
              >
                <img src={file.preview} alt="avatar" />
                <span>Edit</span>
              </div>
            ))
          : this.props.content}
      </Dropzone>
    );
  }
}

AvatarUpload.propTypes = {
  onDrop: PropTypes.func,
  content: PropTypes.node
};

export default AvatarUpload;
